import React, { useEffect, useRef, useState } from 'react';
import { Icon } from './Icon.jsx';

export function UserMenu({ user, onLogout, onShowShortcuts, onShowPrinciples }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  const initials = user.name
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('');
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          all: 'unset',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          padding: '4px 8px 4px 4px',
          borderRadius: 999,
          background: open ? 'var(--sp-bg-page)' : 'transparent',
        }}
      >
        <div className="tt-avatar">{initials}</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1.2,
            marginRight: 2,
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 600 }}>{user.name}</span>
          <span style={{ fontSize: 11, color: 'var(--sp-fg-3)' }}>
            {user.department}
          </span>
        </div>
        <span style={{ color: 'var(--sp-fg-4)', display: 'inline-flex' }}>
          <Icon name="chevD" size={14} />
        </span>
      </button>
      {open && (
        <div
          className="tt-pop"
          style={{
            top: 'calc(100% + 6px)',
            right: 0,
            left: 'auto',
            minWidth: 240,
            padding: 6,
          }}
        >
          <div
            style={{
              padding: '10px 12px 12px',
              borderBottom: '1px solid var(--sp-border)',
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 600 }}>{user.name}</div>
            <div style={{ fontSize: 12, color: 'var(--sp-fg-3)' }}>
              {user.email}
            </div>
            <div
              style={{
                fontSize: 11,
                color: 'var(--sp-fg-3)',
                marginTop: 4,
              }}
            >
              Session expires after 60m of inactivity
            </div>
          </div>
          {(onShowShortcuts || onShowPrinciples) && (
            <div style={{ padding: 4 }}>
              {onShowPrinciples && (
                <button
                  onClick={() => {
                    setOpen(false);
                    onShowPrinciples();
                  }}
                  style={{
                    all: 'unset',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '9px 12px',
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 500,
                    color: 'var(--sp-fg-1)',
                    width: 'calc(100% - 0px)',
                  }}
                >
                  <span
                    style={{
                      display: 'inline-flex',
                      color: 'var(--sp-fg-3)',
                    }}
                  >
                    <Icon name="sparkle" size={15} />
                  </span>
                  <span style={{ flex: 1 }}>Logging principles</span>
                </button>
              )}
              {onShowShortcuts && (
                <button
                  onClick={() => {
                    setOpen(false);
                    onShowShortcuts();
                  }}
                  style={{
                    all: 'unset',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '9px 12px',
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 500,
                    color: 'var(--sp-fg-1)',
                    width: 'calc(100% - 0px)',
                  }}
                >
                  <span
                    style={{
                      display: 'inline-flex',
                      color: 'var(--sp-fg-3)',
                    }}
                  >
                    <Icon name="info" size={15} />
                  </span>
                  <span style={{ flex: 1 }}>Keyboard shortcuts</span>
                  <span style={{ fontSize: 11, color: 'var(--sp-fg-3)' }}>
                    ?
                  </span>
                </button>
              )}
            </div>
          )}
          <div
            style={{
              borderTop: '1px solid var(--sp-border)',
              padding: 4,
            }}
          >
            <button
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
              style={{
                all: 'unset',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 12px',
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 500,
                color: '#B30745',
              }}
            >
              <span style={{ display: 'inline-flex', color: '#B30745' }}>
                <Icon name="out" size={15} />
              </span>
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
